import React, { ComponentProps } from 'react';

import { LoadingButton } from '@atlaskit/button';

export function SelectActionButton({
  appearance = 'link',
  spacing = 'compact',
  style = { margin: '8px 2px 0px 2px' },
  ...rest
}: ComponentProps<typeof LoadingButton>): JSX.Element {
  return (
    <LoadingButton
      {...rest}
      appearance={appearance}
      spacing={spacing}
      style={style}
    />
  );
}
